<template>
<!-- <q-dialog v-model="show_player" seamless position="bottom" v-if="$q.platform.is.desktop"></q-dialog> -->
    <div>

        <q-dialog v-model="show_modal" seamless maximized position="bottom">
        <q-card :style="$q.platform.is.mobile ? '' : 'min-width: 80vw; max-height: 80vh; z-index: 999;'">
            <q-toolbar>
                <q-toolbar-title>
                    <q-icon name="far fa-cookie-bite" class="q-mx-md" />
                    {{ $t('cookies_policy') }}
                </q-toolbar-title>
            </q-toolbar>

            <q-separator />

            <q-card-section class="linkfix">
                <p class="text-h5">{{ $t('lets_talk_about_privacy') }}</p>
                <p class="text-subtitle1">{{ $t('cookies_policy_information') }}</p>
                <p class="text-subtitle2 cursor-pointer" @click="show_policy = true">
                    <em>{{ $t('to_understand_why_we_use_cookies') }}</em>
                </p>
                
                <div class="row">
                    <div class="col-12 text-right q-mt-md">
                        <q-btn flat color="negative" :label="$t('refuse')" icon="fal fa-ban" @click="refuse()" class="q-mr-md" />
                        <q-btn flat color="positive" :label="$t('accept')" icon="fal fa-check" @click="accept()" />
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </q-dialog>

    <q-dialog v-model="show_policy" persistent transition-show="scale" transition-hide="scale">
      <q-card>
        <q-card-section>
          <div class="text-h6">
              <q-icon name="far fa-cookie-bite" class="q-mx-md" />
              {{ $t('cookies_policy') }}
              </div>
        </q-card-section>

        <q-card-section class="q-pt-none linkfix">
          <span v-html="policies"></span>
        </q-card-section>

        <q-card-actions align="right" class="bg-white primary">
            <div class="row">
                <div class="col-12 text-right">
                    <q-btn flat color="primary" :label="$t('ok')" @click="show_policy = false" class="q-mr-md" />
                </div>
            </div>
        </q-card-actions>
      </q-card>
    </q-dialog>

    </div>
    
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'AcceptTermsAndConditions',

    i18nOptions: { namespaces: ['custom', 'common'] },

    data() {
        return {
            show_modal: false,
            show_policy: false,
            cookies_policies: []
        }
    },

    computed: {
        ...mapGetters({
            id_user_language_selected: 'common/id_user_language_selected',
            register: 'params/register'
        }),

        policies() {
            let obj = this.cookies_policies.find(obj => obj.language === this.id_user_language_selected && obj.body !== null)
            if (obj) return obj.body
            else {
                let obj = this.cookies_policies.find(obj => obj.body !== '')
                if (obj) return obj.body
            }
            return ''
        }
    },

    methods: {
        getCookiesPolicy() {
            this.$axios.get('/etraining_login/cookies_policy/')
	        .then(response => {
                this.cookies_policies = response.data
                this.show_modal = true
            })
            .catch(e => {
                console.log(e)
            })
        },

        refuse() {
            this.show_modal = false
            this.$store.dispatch('common/SET_ACCESS_TOKEN', ['', '', ''])

            setTimeout(() =>{
                this.$q.loading.hide()
                this.$router.replace({ name: 'login' })
            }, 700)
        },

        accept() {
            this.$q.loading.show()

            let fd = new FormData()
            fd.append('accept', true)

            this.$axios.post('/register_user/user_accept_cookies_policy/', fd)
            .then(response => {
                this.show_modal = false
                this.show_policy = false

                this.$store.dispatch('common/SET_COOKIES_POLICY', [response.data.accepted_date])
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        }
    },

    mounted() {
        if (this.accept_cookies_policy === false) this.getCookiesPolicy()
    },

    watch: {
		  accept_cookies_policy: function(){
            if (this.accept_cookies_policy === false) {
                this.getCookiesPolicy()
            }
		},
	},
}
</script>

<style>

</style>
